<div class="flex" [ngClass]="{'sidebar-active': app.sidebarActive}">
	<div class="sidebar-next-right-block">
		<div class="partner-right-block-body">
			<div class="settings-authorized-representative-header flex">
				<div class="settings-authorized-representative-header-label">Authorized Representative</div>
				<button [disabled]="true" class="btn-darkblue" pButton label="Update" style="width: 90px; height: 45px; margin-left: auto"></button>
			</div>
			<div class="settings-authorized-representative-label">Company Owner or nominated representative details</div>

			<div class="flex flex-row" style="grid-gap: 95px;">
				<div style="width: 640px;">
					<div class="settings-authorized-representative-input-item-normal">
						<div class="settings-authorized-representative-input-label">Company position</div>
						<input [ngModel]="merchantInfo.CompanyPosition" [disabled]="true" class="settings-authorized-representative-input" type="text" pInputText />
					</div>
					<div class="flex flex-row" style="grid-gap: 20px;">
						<div class="settings-authorized-representative-input-item-min">
							<div class="settings-authorized-representative-input-label">Salutation</div>
							<input [ngModel]="merchantInfo.Salutation" [disabled]="true" class="settings-authorized-representative-input" type="text" pInputText />
						</div>
						<div style="width: 70%;">
							<div class="settings-authorized-representative-input-label">First Name</div>
							<input [ngModel]="merchantInfo.FirstName" [disabled]="true" class="settings-authorized-representative-input" style="width: 100%;" type="text" pInputText />
						</div>
						<div class="settings-authorized-representative-input-item-min">
							<div class="settings-authorized-representative-input-label">Suffix</div>
							<input [ngModel]="merchantInfo.Suffix" [disabled]="true" class="settings-authorized-representative-input" type="text" pInputText />
						</div>
					</div>
					<div class="flex flex-row" style="grid-gap: 20px;">
						<div style="width: 90%;">
							<div class="settings-authorized-representative-input-label">Last Name</div>
							<input [ngModel]="merchantInfo.LastName" [disabled]="true" class="settings-authorized-representative-input" style="width: 100%;" type="text" pInputText />
						</div>
						<div class="settings-authorized-representative-input-item-min">
							<div class="settings-authorized-representative-input-label">Suffix</div>
							<input [ngModel]="merchantInfo.Suffix" [disabled]="true" class="settings-authorized-representative-input" type="text" pInputText />
						</div>
					</div>
					<div style="width: 100%">
						<div class="settings-authorized-representative-input-label">Home Address</div>
						<input [ngModel]="merchantInfo.Address" [disabled]="true" class="settings-authorized-representative-input settings-authorized-representative-input-item" type="text" pInputText />
						<div class="flex flex-row settings-authorized-representative-input-item" style="grid-gap: 20px;">
							<input [ngModel]="merchantInfo.City" [disabled]="true" class="settings-authorized-representative-input" type="text" pInputText />
							<input [ngModel]="merchantInfo.PostalCode" [disabled]="true" class="settings-authorized-representative-input" type="text" pInputText />
						</div>
					</div>
					<div class="flex flex-row" style="width: 100%; grid-gap: 20px;">
						<div class="settings-authorized-representative-input-item" style="width: 50%">
							<div class="settings-authorized-representative-input-label">Date of Birth</div>
							<input [ngModel]="merchantInfo.Birthday" [disabled]="true" class="settings-authorized-representative-input" type="text" pInputText />
						</div>
						<div class="settings-authorized-representative-input-item" style="width: 50%">
							<div class="settings-authorized-representative-input-label">Nationality</div>
							<input [ngModel]="merchantInfo.NationalityStr" [disabled]="true" class="settings-authorized-representative-input" type="text" pInputText />
						</div>
					</div>
					<div class="flex flex-row" style="width: 100%; grid-gap: 20px;">
						<div class="settings-authorized-representative-input-item" style="width: 50%">
							<div class="settings-authorized-representative-input-label">Cellphone Phone</div>
							<input [ngModel]="merchantInfo.Phone" [disabled]="true" class="settings-authorized-representative-input" type="text" pInputText />
						</div>
						<div class="settings-authorized-representative-input-item" style="width: 50%">
							<div class="settings-authorized-representative-input-label">Email</div>
							<input [ngModel]="merchantInfo.Email" [disabled]="true" class="settings-authorized-representative-input" type="text" pInputText />
						</div>
					</div>
				</div>

				<div>
					<div class="flex flex-row" style="grid-gap: 135px;">
						<div style="width: 285px">
							<div class="settings-authorized-representative-input-label">Company Authorization Letter</div>

							<div class="settings-authorized-representative-input-label-min">Issue Date</div>
							<input [ngModel]="merchantInfo.CompanyAuthorizationLetterIssueDate" [disabled]="true" class="settings-authorized-representative-input settings-authorized-representative-input-item" type="text" pInputText />

							<div class="settings-authorized-representative-input-label-min">Expiration Date</div>
							<input [ngModel]="merchantInfo.CompanyAuthorizationLetterExpirationDate" [disabled]="true" class="settings-authorized-representative-input settings-authorized-representative-input-item" type="text" pInputText />

							<div class="settings-authorized-representative-input-label-min">Document Number</div>
							<input [ngModel]="merchantInfo.CompanyAuthorizationLetterNumber" [disabled]="true" class="settings-authorized-representative-input settings-authorized-representative-input-item" type="text" pInputText />
						</div>

						<div *ngIf="merchantInfo.CompanyAuthorizationLetterImageUrl">
							<p-image [src]="merchantInfo.CompanyAuthorizationLetterImageUrl" alt="Image" width="220" [preview]="true"></p-image>
						</div>
					</div>

					<div>
						<div style="width: 640px">
							<div class="settings-authorized-representative-input-label">Personal Identification</div>

							<div class="flex flex-row" style="grid-gap: 72px">
								<div style="width: 285px">
									<div class="settings-authorized-representative-input-label-min">Issue Date</div>
									<input [ngModel]="merchantInfo.PersonalIdentificationIssueDate" [disabled]="true" class="settings-authorized-representative-input settings-authorized-representative-input-item" type="text" pInputText />
								</div>
								<div style="width: 285px">
									<div class="settings-authorized-representative-input-label-min">ID Type</div>
									<input [ngModel]="merchantInfo.PersonalIdentificationTypeStr" [disabled]="true" class="settings-authorized-representative-input settings-authorized-representative-input-item" type="text" pInputText />
								</div>
							</div>
							<div class="flex flex-row" style="grid-gap: 72px">
								<div style="width: 285px">
									<div class="settings-authorized-representative-input-label-min">Expiration Date</div>
									<input [ngModel]="merchantInfo.PersonalIdentificationExpirationDate" [disabled]="true" class="settings-authorized-representative-input settings-authorized-representative-input-item" type="text" pInputText />

									<div class="settings-authorized-representative-input-label-min">Document Number</div>
									<input [ngModel]="merchantInfo.PersonalIdentificationNumber" [disabled]="true" class="settings-authorized-representative-input settings-authorized-representative-input-item" type="text" pInputText />
								</div>
								<div *ngIf="merchantInfo.PersonalIdentificationImageUrl">
									<p-image [src]="merchantInfo.PersonalIdentificationImageUrl" alt="Image" width="285" [preview]="true"></p-image>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<p-toast position="top-right"></p-toast>
